$('.custom_testimonials .blocks_container').slick({
    infinite:false,
    slidesToShow: 1,
    dots:true,
    speed:300,
    slidesToScroll: 1,
    prevArrow: false,
    nextArrow: false
  });
      

  document.querySelectorAll('.custom_faq .block_item').forEach(item => {
    item.addEventListener('click', () => {
        // Iterate through all items
        document.querySelectorAll('.custom_faq .block_item').forEach(block => {
            // Remove 'active' class from all items except the clicked one
            if (block !== item) {
                block.classList.remove('block_active');
                // Reset height of .inner-content for non-active items
                block.querySelector('.inner-content').style.height = '0';
            }
        });

        // Toggle 'active' class on the clicked item
        item.classList.toggle('block_active');

        // Set height of .inner-content dynamically for the clicked item
        const innerContent = item.querySelector('.inner-content');
        if (item.classList.contains('block_active')) {
            // Calculate the natural height of .inner-content
            const naturalHeight = innerContent.scrollHeight + 'px';
            innerContent.style.height = naturalHeight;
        } else {
            // Reset height of .inner-content if the item is not active anymore
            innerContent.style.height = '0';
        }
    });
});




// document.addEventListener('DOMContentLoaded', function() {
//     const headings = document.querySelectorAll('.toggle-heading');
//     const contents = document.querySelectorAll('.inner-content');
//     const icons = document.querySelectorAll('.toggle-icon');

//     headings.forEach(function(heading, index) {
//         heading.addEventListener('click', function() {
//             if (contents[index].style.display === 'none' || contents[index].style.display === '') {
//                 contents[index].style.display = 'block';
//                 icons[index].textContent = '-';
//             } else {
//                 contents[index].style.display = 'none';
//                 icons[index].textContent = '+';
//             }
//         });
//     });
// });

document.addEventListener('DOMContentLoaded', function() {
    const headings = document.querySelectorAll('.toggle-heading');
    const icons = document.querySelectorAll('.toggle-icon');

    headings.forEach(function(heading, index) {
        heading.addEventListener('click', function() {
            // Reset all icons to '+'
            icons.forEach(function(icon, iconIndex) {
                if (iconIndex !== index) {
                    icon.textContent = '+';
                }
            });

            // Toggle the current icon
            if (icons[index].textContent === '+') {
                icons[index].textContent = '-';
            } else {
                icons[index].textContent = '+';
            }
        });
    });
});



// document.addEventListener('DOMContentLoaded', function() {
//     const headings = document.querySelectorAll('.toggle-heading');
//     const icons = document.querySelectorAll('.toggle-icon');

//     headings.forEach(function(heading, index) {
//         heading.addEventListener('click', function() {
//             if (icons[index].src.includes('plus.png')) {
//                 icons[index].src = 'https://cdn.shopify.com/s/files/1/1221/4172/files/minimize-sign_1.png?v=1719404599'; // Update with the correct path to your minus image
//             } else {
//                 icons[index].src = 'https://cdn.shopify.com/s/files/1/1221/4172/files/plus-sign.png?v=1719404599'; // Update with the correct path to your plus image
//             }
//         });
//     });
// });

// $('.spa-party-slider .blocks_container').slick({
//     infinite: true,
//     slidesToShow:4,
//     slidesToScroll:4,
//     prevArrow: false,
//     nextArrow: false
//   });

  
$('.spa-party-slider .blocks_container').slick({
    dots:false,
    infinite:true,
    speed: 300,
    slidesToShow: 4,
    prevArrow: false,
    nextArrow: false,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots:false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });